import * as React from "react";
import ContentCard from "../../../../ui-library/content-card/content-card";
import { RainBow } from "../../../../design-tokens/colors";
import SourceLink from "../../../../ui-library/source-link/source-link";
import { EventCategory } from "../../../../../utils/analytics";
import CardContent from "../../../../ui-library/content-card/card-content";
import CardHeading from "../../../../ui-library/content-card/card-heading";
import CardSubHeading from "../../../../ui-library/content-card/card-sub-heading";
import TimelinePoint from "../../../../ui-library/timeline-point/timeline-point";
import { COVID_SOURCES } from "../../../../../constants/sources";
import { COVID_TIMELINE } from "./covid-timeline-data";
import styles from "./covid-timeline.styles";

const colorMapping: { [key: number]: RainBow } = {
  12: RainBow.Pink,
  1: RainBow.Plum,
  2: RainBow.Grape,
  3: RainBow.BlueBerry,
  4: RainBow.SkyBlue,
  5: RainBow.Teal,
};

const CovidTimeline: React.FC = () => {
  return (
    <ContentCard>
      <CardContent>
        <CardHeading>COVID-19 timeline</CardHeading>

        <CardSubHeading>
          A comprehensive timeline of the new coronavirus pandemic, from China's
          first COVID-19 case to the present
        </CardSubHeading>

        <div css={styles.timeline}>
          {COVID_TIMELINE.map((event, index) => {
            const date = new Date(event.date);

            const color = colorMapping[date.getMonth() + 1] || RainBow.SkyBlue;

            return (
              <TimelinePoint
                key={event.label.slice(0, 16)}
                {...event}
                color={color}
                showYear={index === 0 || index === 1}
              />
            );
          })}
        </div>

        <SourceLink
          sources={[COVID_SOURCES.BusinessInsider]}
          eventCategory={EventCategory.Section_Timeline}
        />
      </CardContent>
    </ContentCard>
  );
};

export default CovidTimeline;
